//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["openStatus", "infoFareInfo", "orderId"],
  // props: ["openStatus", "orderId"],
  data() {
    return {
      stepLoading: false,
      dialogVisible_fy: false,
      tableData: [
        {
          totalPay: "",
          oredrPrice: "",
          freightMoney: "",
          discountPrices: "",
          remitMoneyPrice: "",
          id: "",
        },
      ],
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_fy = this.openStatus;
    },
    infoFareInfo(val1, val2) {
      this.$store.state.szStatus.szDetailsObj = val1;
      this.tableData = this.$store.state.szStatus.szDetailsObj;
    },
    // tableData (val1, val2){
    //   this.tableData = val1
    // }
    // infoFareInfo(val1, val2){
    //   this.tableData = val1
    // }
  },
  mounted() {
    // this.tableData = this.infoFareInfo;
    this.tableData = this.$store.state.szStatus.szDetailsObj;
    // this.tableData = JSON.parse(sessionStorage.getItem("infoFareInfo"));
    // console.log(this.tableData);
  },
  methods: {
    // 修改费用接口
    submitForm() {
      this.stepLoading = true;
      let costParams = {
        discountPrices: this.tableData[0].discountPrices,
        freightMoney: this.tableData[0].freightMoney,
        orderId: this.orderId,
        remitMoneyPrice: this.tableData[0].remitMoneyPrice,
        totalPay: this.tableData[0].totalPay,
        oredrPrice: this.tableData[0].oredrPrice,
        id: this.tableData[0].id,
      };
      this.$http.szOrder.editCost(costParams).then((res) => {
         this.stepLoading = false;
        if (res.status == 1) {
          this.dialogVisible_fy = false;
          this.$emit("closeStatus", true);
          this.$message({
            message: "修改成功",
            type: "success",
          });
          setTimeout(() => {
            this.stepLoading = false;
          }, 1000);
        }
      });
    },
    handleClose() {
      this.dialogVisible_fy = false;
      this.$emit("closeStatus", true);
    },
  },
};
